/**
 * Taxas de máquina de cartão por bandeira e modalidade (crédito/débito).
 * Linha de taxa: { modalidade, bandeira ('' = padrão), parcelas, taxaPercentual, taxaAntecipacaoPercentual }.
 * Sem taxa própria da bandeira, vale a taxa padrão da máquina (bandeira '').
 */
export const BANDEIRAS = ['Visa', 'Mastercard', 'Elo', 'American Express', 'Hipercard'];

const doTipo = (maquina, modalidade) =>
  (maquina?.taxas || []).filter(t => (t.modalidade || 'credito') === modalidade);

// Taxa da combinação; cai no padrão quando a bandeira não tem linha própria
export function acharTaxa(maquina, { modalidade = 'credito', bandeira = '', parcelas = 1 }) {
  const linhas = doTipo(maquina, modalidade).filter(t => String(t.parcelas) === String(parcelas));
  return linhas.find(t => (t.bandeira || '') === bandeira) || linhas.find(t => !t.bandeira) || null;
}

// Quantidades de parcela disponíveis para a bandeira (própria + padrão), com a taxa de cada uma
export function parcelasDisponiveis(maquina, bandeira = '') {
  const porParcela = new Map();
  doTipo(maquina, 'credito').forEach(t => {
    if (!t.bandeira && !porParcela.has(t.parcelas)) porParcela.set(t.parcelas, t);
  });
  if (bandeira) doTipo(maquina, 'credito').filter(t => t.bandeira === bandeira).forEach(t => porParcela.set(t.parcelas, t));
  return [...porParcela.values()].sort((a, b) => a.parcelas - b.parcelas);
}
